import React from "react";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ColDynamic from "../WrapperComponents/ColDynamic";
import InputComponent from "../../UI/InputComponent/InputComponent";
import BasicAddressData from "../BasicAddressData/BasicAddressData";
import Dropdown from "../../UI/Dropdown/Dropdown";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import Select from "react-virtualized-select";

const NamesAndAddressesNetworkList = (props) => {
  const { networksList } = props.parentState;

  


  const networkListOptions = networksList.map((element) => (
    <option key={element.idMreze} value={element.idMreze}>
      {element.nazMreze}
    </option>
  ));

  const { networkMemberInfo } = props.parentState;

  const memberObj =
    networkMemberInfo.isDrustvoMreza != "0"
      ? [
          { id: 1, value: "Član" },
          { id: 2, value: "Povezano društvo" },
        ]
      : [{ id: 2, value: "Povezano društvo" }];
  const memberInfo = props.parentState.newFormData.memberInfo.find(
    (element) => element.id == props.id
  );

  const arrayLength = props.parentState.newFormData.memberInfo.length > 1;

  const memberOptions = memberObj.map((element) => (
    <option key={element.id} value={element.id}>
      {element.value}
    </option>
  ));

  const selectStyle = { borderColor: "red" };

  return (
    <>
      <Row>
        <Col>
          <label>
            {props.required
              ? "Oznaka člana ili povezanog društva*"
              : "Oznaka člana ili povezanog društva"}
          </label>
          <Select
            noResultsText={"Nema rezultata"}
            placeholder="Odaberite člana ili povezano društvo"
            options={memberObj}
            onChange={(selectValue) =>
              props.vrClanaDropdownHandler(selectValue, props.id)
            }
            labelKey="value"
            valueKey="id"
            value={memberInfo.vrClana}
          />
        </Col>
        {memberInfo.vrClana === "" && <Col></Col>}
        {memberInfo.vrClana == 1 && (
          <Col>
            <Dropdown
              id={`member-info-dropdown${props.id}`}
              label={"Pripadnost mreži"}
              onChange={props.setSelectedNetworkToArray}
              value={memberInfo.idMreze}
              hidden
              asProperty="select"
              map={networkListOptions}
              text="Odaberite mrežu"
            />
          </Col>
        )}
        {memberInfo.vrClana == 2 && (
          <Col>
            <InputComponent
              style={
                props.parentState.error &&
                props.required &&
                memberInfo.nazDrustva.length < 1 &&
                "red"
              }
              id={`member-info-naziv-drustva${props.id}`}
              name="nazDrustva"
              required={props.required}
              onChange={props.mappedUserInputHandler}
              objData={{ id: props.id, group: "memberInfo" }}
              value={memberInfo.nazDrustva}
              controlLabel="Naziv društva"
            />
          </Col>
        )}
      </Row>

      {((memberInfo.idMreze && memberInfo.vrClana == 1) ||
        memberInfo.vrClana == 2) && (
        <>
          <BasicAddressData
            required
            hackId="member-info"
            requiredBrPoste={memberInfo.web.length < 1}
            requiredNazNaselja={memberInfo.web.length < 1}
            requiredKbr={memberInfo.web.length < 1}
            objData={{ id: props.id, group: "memberInfo" }}
            onChange={props.mappedUserInputHandler}
            address={memberInfo}
            {...props}
          />
          <Row>
            <ColDynamic className="col-lg-8 input-style">
              <InputComponent
                required={
                  memberInfo.nazNaselja.length < 1 ||
                  memberInfo.brPoste.length < 1 ||
                  memberInfo.ulicaKbr.length < 1
                }
                style={
                  props.parentState.error &&
                  memberInfo.web.length < 1 &&
                  (memberInfo.nazNaselja.length < 1 ||
                    memberInfo.brPoste.length < 1 ||
                    memberInfo.ulicaKbr.length < 1) &&
                  "red"
                }
                id={`member-info-web${props.id}`}
                name="web"
                onChange={props.mappedUserInputHandler}
                objData={{ id: props.id, group: "memberInfo" }}
                value={memberInfo.web}
                controlLabel="Web adresa za provjeru podataka"
              />
            </ColDynamic>
          </Row>
        </>
      )}
      <br></br>
      <Row>
        <ColDynamic className="col-lg-4">
          {props.parentState.newFormData.memberInfo.length - 1 === props.idZaBtn ?
            <ButtonComponent
              id={`member-info-multiply${props.id}`}
              onClick={(e) =>
                props.multiplyComponent(e, { formGroup: props.group })
              }
            >
              Dodaj novi
            </ButtonComponent>
          : null
        }
        </ColDynamic>
        <ColDynamic className="col-lg-4">
          {arrayLength && (
            <ButtonComponent
              variant="danger"
              id={`member-info-remove${props.id}`}
              onClick={(e) =>
                props.removeComponentHandler(e, { formGroup: props.group })
              }
            >
              Ukloni
            </ButtonComponent>
          )}
        </ColDynamic>
      </Row>
    </>
  );
};

export default NamesAndAddressesNetworkList;
